module.exports = __webpack_public_path__ + "img/phone.04e786c5.png";